import { Result } from 'antd';
import  { API_BASE_URL }  from '../../config/constants';
import {getRequest, postRequest} from '../API';

/*********************************************************
 *  This function is use to login api
 *********************************************************/
export const login = async (options)=>{
    try{
        const {email}= options;
        if(!email){
            return {status : false, message:"Email Address/ Mobile Number is required"}
        } else{
            const posrData ={ 
                url : API_BASE_URL+'/investors/login',
                postData : options
             }
            const res = await postRequest(posrData);
            if(res.status === true || res.status === 200){
                return {status : true, message:`Your One Time Password is sent to ${email}`}
            } else{
                return {status : false, message:res?.response?.data?.statusMessage}
            }
        }
    }catch(error){
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
}; //End of Function

/*********************************************************
 *  This function is use to login api
 *********************************************************/
export const verifyOTP = async (options)=>{
    try{
        const {email}= options;
        if(!email){
            return {status : false, message:"Your one-time password has expired or is incorrect. Please try again."}
        } else{
            const posrData ={ 
                url : API_BASE_URL+'/investors/verify-login-otp',
                postData : options
             }
            const res = await postRequest(posrData);
            if(res.status === true || res.status === 200){
                sessionStorage.setItem('TOKEN', res.data.response.result.token);
                sessionStorage.setItem('USER-INFO', JSON.stringify(res.data.response.result));
                sessionStorage.setItem('FIRM-INFO', JSON.stringify(res.data.response.result?.firm));
                const conpanyId = res?.data?.response?.interestList.map((item)=>item.company_data);
                sessionStorage.setItem('INTEREST-DATA', JSON.stringify(conpanyId || []));
                
                return {status : true, message:`Welcome back! ${res.data.response.result.investor_first_name}`, result : res?.data?.response?.result };
            } else{
                return {status : false, message:res?.response?.data?.statusMessage}
            }
        }
    }catch(error){
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
}; //End of Function

/*********************************************************
 *  This function is use to logout user and clear session and local storage
 *********************************************************/
export const logout = async() => {
    try{
        const posrData ={ 
            url : API_BASE_URL+'/investors/logout',
         }
        await getRequest(posrData);
        sessionStorage.clear();
        localStorage.clear();
        return {status : true, message:"Success"}
    } catch(error){
        sessionStorage.clear();
        localStorage.clear();
        return {status : true, message:"Success"}
    }   
}

/*********************************************************
* Function Name : updateProfile
* Description   : this function is used for updateProfile
* By            : Afsar Ali
* Date          : 19-AUG-2024 
*********************************************************/
export const updateProfile = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}/investors/update-profile`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            sessionStorage.setItem('USER-INFO', JSON.stringify(res?.data?.response?.result))
            sessionStorage.setItem('FIRM-INFO', JSON.stringify(res?.data?.response?.result?.firm))
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : investorUserList
* Description   : this function is used for investorUserList
* By            : Afsar Ali
* Date          : 2025-08-13 
*********************************************************/
export const investorUserList = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}/investors/investor-user-list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : sentInvitationEmail
* Description   : this function is used for sentInvitationEmail
* By            : Afsar Ali
* Date          : 2025-08-13 
*********************************************************/
export const sentInvitationEmail = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}/common/sent-invite-mail`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : investorFirmsList
* Description   : this function is used for investorFirmsList
* By            : Sumit Bedwal
* Date          : 2026-08-11 
*********************************************************/
export const investorFirmsList = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}/investors/investing-firms-list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

